import { request } from 'src/api/request';

export const getTreating = async ({ provider_id, queryParams }) => {
  if (!provider_id) return null;
  return request({
    url: `/v1/entities/entity/${provider_id}/affiliations/treating/${queryParams}`,
    method: 'GET',
  });
};

export const getTreatingV2 = async ({ provider_id, queryParams, data }) => {
  if (!provider_id) return null;
  return request({
    url: `v1/entities/v2/entity/${provider_id}/affiliations/treating/${queryParams}`,
    method: 'POST',
    data,
    // Idempotent ES read (params in the body) — opt into the 503 retry.
    retryOn503: true,
  });
};
